import React from "react";
import Spinner from "../presentationals/Spinner";

export const CustomCardStock = (props) => {
  function csvHandler(e) {
    e.preventDefault();
    props.csvDownload(props.tileName);
  }
  return (
    <>
      <div className="col-md-4" data-cy={props.tileName}>
        <div className={`stockbox ${props.cardColor}  whiteoverlaycir`}>
          <div className="row staticHeightStock">
            <div className="col-md-8 col-8">
              <div className="textdiv fw-bold">{props.tileName}</div>
            </div>

            {props.csvDownload && (
              <div className="col-md-4 col-4">
                {props.loading && props.loading[props.tileName] ? (
                  <div style={{ float: "right" }}>
                    <Spinner showAlert={false} />
                  </div>
                ) : (
                  <span className="downloadarrow mb-2">
                    <button
                      type="button"
                      className="btn btn-link btn-sm m-0 p-0"
                      onClick={csvHandler}
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icons/download-arrow.svg"
                        }
                        alt="download"
                      />
                    </button>
                  </span>
                )}
              </div>
            )}
          </div>
          <div className="row mt-2">
            <div className="col-md-6 col-6">
              <div className="icondiv col-6">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    `/assets/images/icons/${props.icon}.svg`
                  }
                  alt="telephone"
                />
              </div>
            </div>
            <div className="col-md-6 col-6 text-end float-end pt-3">
              <h3 className="count-numbers fw-bold">{props.value}</h3>
              {/* <p className="count-name">{props.tileName}</p> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
